import React, { Component } from 'react'
import styles from "./CollectMap.module.css"

import GridBox from "../../util/ExtendBlock/GridBox";
import ImgInteract from "../../util/ImgInteract";
import CtxComp from "../../util/CanvasPkg/CtxComp"
import ExtendPullBar from "./ExtendPullBar"
import FloatText from "../../util/FloatText"
import EmptyComp from "../../util/ExtendBlock/EmptyComp";
import WallPaperBtn from "../../util/WallPaperBtn"
import EditCompWrap from "../../util/CanvasPkg/EditCompWrap"

import { v4 as uuidv4 } from 'uuid';
import ToolFunc from "../../util/CommToolFunc"

const EXTENDBAR_MARGIN_TOP = 10
const SELECTED_STYLE = "5px solid red"

// This component is set for layout element and placement
export default class CollectMap extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectId: null,
            gridSelectFlag: false,
            updateCount: 0,
        };
        // this.props.pick = { updateType: null, imgSrc: null, tool: null}

        //dom reference element
        this.contentList = {}
        this.shapeContentList = {}
        this.contentListState = {} //{name:contentType, state}

        this.gridInfo = { color: "#f1d2a4", alpha: 1, height: window.innerHeight * 5 / 6 }

        this.selectId = null
        this.selectCtxCompId = null
        //setting default value from props
        this.defaultRgba = (this.props.defaultRgba) ? this.props.defaultRgba : { color: "#FFFFFF", alpha: 1 }
    }

    //sub-component
    wallPaperCallback = (selectFlag) => {
        if (this.props.toolBarColorCallback)
            this.props.toolBarColorCallback({ color: this.gridInfo.color, alpha: this.gridInfo.alpha })
        this.setState(state => { return { gridSelectFlag: selectFlag } })
    }
    // handler
    createContentHandler = (id) => {
        //remove select id, cause it would create new extendBlock
        if (this.selectId && this.contentList[this.selectId]) {
            const targetType = this.contentListState[this.selectId].name
            this.contentListState[this.selectId].state.select = false
            this.contentList[this.selectId] = this.updateContentDeclaration(this.selectId, targetType);
        }

        //put the new one with EMPTY wrap
        this.selectId = id
        this.contentListState[id] = { name: "Empty", state: { select: true } }
        this.contentList[id] = this.updateContentDeclaration(id, "Empty");
    }
    selectHandler = (id) => {
        //remove previous id
        if (this.selectId && this.contentList[this.selectId]) {
            const targetType = this.contentListState[this.selectId].name
            this.contentListState[this.selectId].state.select = false
            this.contentList[this.selectId] = this.updateContentDeclaration(this.selectId, targetType);
        }

        this.selectId = id
        if (this.contentListState[id]) {
            this.contentListState[id].state.select = true
            this.contentList[id] = this.updateContentDeclaration(id, this.contentListState[id].name);
        } else {
            this.selectId = null
        }

        this.setState(state => { return { updateCount: state.updateCount + 1 } })
    }
    removeContentHandler = (id) => {
        if (Object.keys(this.contentList).length == 1)
            return;
        delete this.contentList[id];
        delete this.contentListState[id]
    }

    /**********************
     * Ctx control Handler
     **********************/
    createShapeList = () => {
        //create list
        var shapeComponentList = []
        for (let k in this.shapeContentList)
            shapeComponentList.push(this.shapeContentList[k])

        return shapeComponentList
    }
    selectCtxCompHandler = (id) => {
        //it must send back to tool to set current shape color
        this.selectCtxCompId = id
        if (this.selectCtxCompId != null && this.selectCtxCompId in this.contentListState) {
            const color = this.contentListState[this.selectCtxCompId].state.color
            const alpha = this.contentListState[this.selectCtxCompId].state.alpha
            if (this.props.toolBarColorCallback)
                this.props.toolBarColorCallback({ color: color, alpha: alpha })
        }
    }
    removeCtxCompHandler = (id) => {
        delete this.shapeContentList[id];
        delete this.contentListState[id];
        this.setState(state => { return { updateCount: state.updateCount + 1 } })
    }

    /**********************************
     * re-generate content declaration
     **********************************/
    updateContentDeclaration = (id, contentType) => {
        var comp = null
        if (contentType == "ImgInteract") {
            comp = <ImgInteract key={id} id={id}
                state={{ ...this.contentListState[id].state }}
                updateStateCB={(state) => this.updateContentStateHandler(id, state)} />
        }
        if (contentType == "FloatText") {
            comp = <FloatText key={id} id={id} {...this.contentListState[id].state}
                selectCallback={this.selectCtxCompHandler}
                deleteCallback={this.removeCtxCompHandler} />
        }
        if (contentType != null && contentType.search("CtxComp") != -1) {
            comp = <EditCompWrap shape={contentType} key={id} id={id} {...this.contentListState[id].state}
                selectCallback={this.selectCtxCompHandler}
                deleteCallback={this.removeCtxCompHandler} />
        }
        if (contentType == "Empty") {
            comp = <EmptyComp key={id} id={id} {...this.contentListState[id].state} />
        }

        return comp
    }
    updateContentStateHandler = (id, updateState) => {
        //backup state
        this.contentListState[id].state = updateState
        const contentType = this.contentListState[id].name

        //refresh declaration
        var comp = this.updateContentDeclaration(id, contentType)
        this.contentList[id] = comp
    }
    refreshSelectComponent = () => {
        const selectId = this.selectId;
        const updateType = this.props.pick.updateType

        if (updateType == null)
            return
        if (selectId && this.contentList[selectId]) {
            var comp = this.contentList[selectId].props.children
            var contentType = null
            //update state in contentListState
            if (updateType == "ImgInteract") {
                //from Empty componet to ImgInteract
                if (this.contentListState[selectId] && this.contentListState[selectId].name != "ImgInteract")
                    this.contentListState[selectId] = {}

                this.contentListState[selectId] = { name: "ImgInteract", state: { src: this.props.pick.imgSrc, select: true } }
                //setting content type
                contentType = "ImgInteract"

                comp = this.updateContentDeclaration(selectId, contentType)
                this.contentList[selectId] = comp
            }
        }

        //create shape component
        if (updateType.search("CtxComp") != -1 || updateType == "FloatText") {
            const id = uuidv4()
            if (this.contentListState[id] && this.contentListState[id].name != updateType)
                this.contentListState[id] = {}
            this.contentListState[id] = { name: updateType, state: { color: this.defaultRgba.color, alpha: this.defaultRgba.alpha } }

            //create new component
            this.shapeContentList[id] = this.updateContentDeclaration(id, updateType)
        }
    }
    updateSelectColor = () => {
        const toolColor = this.props.color.color
        const toolAlpha = this.props.color.alpha
        //update select state and comp
        if (this.state.gridSelectFlag) {
            this.selectCtxCompId = null

            this.gridInfo.color = toolColor
            this.gridInfo.alpha = toolAlpha
        } else if (this.selectCtxCompId && (this.selectCtxCompId in this.contentListState)) {
            const id = this.selectCtxCompId
            this.contentListState[id].state.color = toolColor
            this.contentListState[id].state.alpha = toolAlpha
            this.shapeContentList[id] = this.updateContentDeclaration(id, this.contentListState[id].name)
        }
    }
    extendBarHeightCallback = (height) => {
        this.setState(state => {
            if (height > EXTENDBAR_MARGIN_TOP) {
                this.gridInfo.height = `${height - EXTENDBAR_MARGIN_TOP}`
                return { updateCount: state.updateCount + 1 }
            }
        }, () => {
            if (this.props.gridHeightCallback)
                this.props.gridHeightCallback(this.gridInfo.height)
        })
    }
    componentDidUpdate() { }
    //physical dom refresh
    render() {

        this.updateSelectColor()
        this.refreshSelectComponent()
        var shapeComponentList = this.createShapeList()
        const gridStyle = {
            background: ToolFunc.mergeColorWithAlpha(this.gridInfo.color, this.gridInfo.alpha),
            border: (this.state.gridSelectFlag) ? SELECTED_STYLE : ""
        }
        return (
            <div id="collect-map" className={styles.container}>
                <div className={styles.designStyle} id="design-map-0">
                    <div className={styles.wrapper} style={gridStyle}>
                        <GridBox id="mainGrid" dir={"row"}
                            height={`${this.gridInfo.height}px`}
                            content={this.contentList}
                            contentState={this.contentListState}
                            createContentHandler={this.createContentHandler}
                            selectHandler={this.selectHandler}
                            removeContent={this.removeContentHandler}>
                        </GridBox>
                    </div>
                    {shapeComponentList}
                </div>
                <ExtendPullBar extendBarHeightCallback={this.extendBarHeightCallback} defaultHeight={this.gridInfo.height} />
                <WallPaperBtn clickCallback={this.wallPaperCallback} />
            </div>
        )
    }
}